import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bba-in-computer-application',
  templateUrl: './bba-in-computer-application.component.html',
  styleUrls: ['./bba-in-computer-application.component.scss']
})
export class BbaInComputerApplicationComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
